// extracted by mini-css-extract-plugin
export const layout = "pageLayout-module--layout---267G";